/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeProfileDto
 */
export interface PracticeProfileDto {
    /**
     * Practice name
     * @type {string}
     * @memberof PracticeProfileDto
     */
    practiceName: string;
    /**
     * Practice email
     * @type {string}
     * @memberof PracticeProfileDto
     */
    practiceEmail: string;
    /**
     * Address
     * @type {string}
     * @memberof PracticeProfileDto
     */
    address: string;
    /**
     * City
     * @type {string}
     * @memberof PracticeProfileDto
     */
    city: string;
    /**
     * State
     * @type {string}
     * @memberof PracticeProfileDto
     */
    state: string;
    /**
     * Country
     * @type {string}
     * @memberof PracticeProfileDto
     */
    country: string;
    /**
     * Zip code
     * @type {string}
     * @memberof PracticeProfileDto
     */
    zip: string;
    /**
     * Primary phone number
     * @type {string}
     * @memberof PracticeProfileDto
     */
    primaryPhoneNumber: string;
    /**
     * Fax number
     * @type {string}
     * @memberof PracticeProfileDto
     */
    faxNumber?: string;
    /**
     * Provider email
     * @type {string}
     * @memberof PracticeProfileDto
     */
    email: string;
    /**
     * First name
     * @type {string}
     * @memberof PracticeProfileDto
     */
    firstName: string;
    /**
     * Middle name
     * @type {string}
     * @memberof PracticeProfileDto
     */
    middleName?: string;
    /**
     * Last name
     * @type {string}
     * @memberof PracticeProfileDto
     */
    lastName: string;
    /**
     * National Provider Identifier (NPI)
     * @type {string}
     * @memberof PracticeProfileDto
     */
    npi: string;
    /**
     * Is practice owner
     * @type {boolean}
     * @memberof PracticeProfileDto
     */
    isPracticeOwner?: boolean;
}

/**
 * Check if a given object implements the PracticeProfileDto interface.
 */
export function instanceOfPracticeProfileDto(value: object): value is PracticeProfileDto {
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    if (!('practiceEmail' in value) || value['practiceEmail'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('primaryPhoneNumber' in value) || value['primaryPhoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function PracticeProfileDtoFromJSON(json: any): PracticeProfileDto {
    return PracticeProfileDtoFromJSONTyped(json, false);
}

export function PracticeProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'practiceName': json['practiceName'],
        'practiceEmail': json['practiceEmail'],
        'address': json['address'],
        'city': json['city'],
        'state': json['state'],
        'country': json['country'],
        'zip': json['zip'],
        'primaryPhoneNumber': json['primaryPhoneNumber'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'npi': json['npi'],
        'isPracticeOwner': json['isPracticeOwner'] == null ? undefined : json['isPracticeOwner'],
    };
}

export function PracticeProfileDtoToJSON(json: any): PracticeProfileDto {
    return PracticeProfileDtoToJSONTyped(json, false);
}

export function PracticeProfileDtoToJSONTyped(value?: PracticeProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'practiceName': value['practiceName'],
        'practiceEmail': value['practiceEmail'],
        'address': value['address'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'zip': value['zip'],
        'primaryPhoneNumber': value['primaryPhoneNumber'],
        'faxNumber': value['faxNumber'],
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'npi': value['npi'],
        'isPracticeOwner': value['isPracticeOwner'],
    };
}

